import { type ExtensionManifest } from '@atlaskit/editor-common/extensions';
import { ForgeExtensionManifest, ForgeExtensionParameters } from '../../../types';
import { convertPatternToRegex } from './utils/convertPatternToRegex';
import { isPatternValid } from './utils/isPatternValid';
import { convertLinkToMacroNode } from './utils/convertLinkToMacroNode';
import {
	AutoConvertDefinition,
	AutoConvertMacroAttributes,
	AutoConvertMacroAttributesMap,
} from './types';

const forgeMacroAutoConverter = (
	macroManifests: Array<ForgeExtensionManifest | ExtensionManifest<ForgeExtensionParameters>>,
) => {
	// an array of autoconvert definitions
	const autoConvertDefinitions: AutoConvertDefinition[] = [];

	// a map of macro key to ADF node
	const macroADFNodeMap: AutoConvertMacroAttributesMap = {};

	macroManifests.forEach((manifest) => {
		if (!manifest.autoConvert || !manifest.hasOwnProperty('createExtensionProps')) {
			return;
		}

		const extensionProps = (manifest as ForgeExtensionManifest).createExtensionProps();

		// only macro with autoconvertData can be converted
		manifest.autoConvert.matches.forEach(({ pattern }) => {
			// Invalid patterns will silently fail. We are relying on the CLI linter to warn developers for invalid pattern
			if (isPatternValid(pattern)) {
				macroADFNodeMap[manifest.key] = {
					type: extensionProps.type,
					attrs: {
						extensionKey: manifest.key,
						extensionType: manifest.type,
						parameters: {
							extensionId: extensionProps.attrs.parameters.extensionId,
							extensionTitle: manifest.title,
						},
						layout: 'default',
						text: manifest.title,
					},
				};
				const autoConvertDefinition: AutoConvertDefinition = {
					macroName: manifest.title,
					matcher: convertPatternToRegex(pattern),
					extensionKey: manifest.key,
				};
				autoConvertDefinitions.push(autoConvertDefinition);
			}
		});
	});

	return (link: string) => convertLinkToMacroNode(link, autoConvertDefinitions, macroADFNodeMap);
};

export const createForgeMacroAutoConverter = (
	manifests: Array<ForgeExtensionManifest | ExtensionManifest<ForgeExtensionParameters>>,
): ((link: string) => AutoConvertMacroAttributes | null) => {
	return forgeMacroAutoConverter(manifests);
};
